import { Component, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';

import { throwError } from 'rxjs';
import { catchError, delay, finalize, switchMap, tap } from 'rxjs/operators';

import { Media } from '@sim/media';
import { MediaService } from '@sim/media/services/media.service';
import { extractFileUrl } from '@sim/media/utils';

export interface ImageMediaDialogData {
  media: Media;
}

@Component({
  selector: 'app-image-media-dialog',
  styleUrls: ['./image-media-dialog.component.scss'],
  templateUrl: './image-media-dialog.component.html',
})
export class ImageMediaDialogComponent {

  readonly imageFileUrl$ = this.mediaApi.getBinary(this.data.media.id as string).pipe(
    delay(500),
    switchMap((blob) => extractFileUrl(blob)),
    tap(() => this.spinnerService.hide('loadingImage')),
    catchError((e) => {
      this.dialogRef.close();

      return throwError(e);
    }),
    finalize(() => this.spinnerService.hide('loadingImage')),
  );

  constructor(
    private readonly spinnerService: NgxSpinnerService,
    private readonly mediaApi: MediaService,
    private readonly dialogRef: MatDialogRef<ImageMediaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: ImageMediaDialogData,
  ) {
    this.spinnerService.show('loadingImage');
  }

}
